import { render, staticRenderFns } from "./SignupComponent.vue?vue&type=template&id=b4379cb6&scoped=true&"
import script from "./SignupComponent.vue?vue&type=script&lang=js&"
export * from "./SignupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4379cb6",
  null
  
)

export default component.exports